import { storageFileApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { ServiceResponseI, StorageFileUsageByClientI, StorageFileUsageByBranchI } from "../../interfaces";
import { AxiosError } from "axios";

export const storageGetUsageByClient = async (
  clientId?: string,
): Promise<ServiceResponseI<StorageFileUsageByClientI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    if (clientId) params.append("client", clientId);

    const { data } = await storageFileApi.get<
      ServiceResponseI<StorageFileUsageByClientI[]>
    >("/usage/by-client", {
      params,
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const storageGetUsageByBranch = async (
  clientId: string,
): Promise<ServiceResponseI<StorageFileUsageByBranchI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await storageFileApi.get<
      ServiceResponseI<StorageFileUsageByBranchI[]>
    >(`/usage/by-branch/${clientId}`, {
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};